import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { TeamTimeEntryForm, TeamTimeEntryData } from "./TeamTimeEntryForm";
import { TeamProject } from "@/types/TeamProject";
import { CollaborativeProject } from "@/types/CollaborativeProject";
import { useState } from "react";

interface TeamTimeEntryDialogProps {
  project: TeamProject | CollaborativeProject;
  onSubmit: (entry: TeamTimeEntryData) => void;
  trigger?: React.ReactNode;
}

export function TeamTimeEntryDialog({ project, onSubmit, trigger }: TeamTimeEntryDialogProps) {
  const [open, setOpen] = useState(false);

  const handleSubmit = (entry: TeamTimeEntryData) => {
    onSubmit(entry);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button className="gap-2">
            <Plus className="h-4 w-4" />
            Log Time
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Log Time - {project.name}</DialogTitle>
        </DialogHeader>
        <TeamTimeEntryForm project={project} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
}